import React from "react";
import { useDispatch } from "react-redux";
import { Dialog, Button, Typography, Divider } from "@material-ui/core";
import BlockIcon from "@material-ui/icons/Block";
import { StorageUser } from "../../../../../main/StorageUser";
import { updateOrderStatus } from "../../../../../state/order/actions";
import { STATUS } from "../../../../../main/status";
import Authorization from "../../../Authorization";
import useStyles from "./CancelOrderDialog.styles";

export default function CancelOrderDialog({
  orderNumber,
  origem,
  codigoExterno,
  canalDeVendas,
  loja,
  open,
  setState,
}) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const storageUser = new StorageUser();
  const requireAutorizador = storageUser.allowedByPermission(
    "INLINE_CANCEL_CONFIRM"
  );
  const isPegueNaLoja = origem === "PEGUE_NA_LOJA";
  const numero = isPegueNaLoja
    ? (codigoExterno || "").split("#")[0]
    : codigoExterno;

  const handleClose = () => setState({ modalOpen: false });

  const handleCancelar = ({ nomeAutorizador, emailAutorizador } = {}) => {
    dispatch(
      updateOrderStatus({
        origem,
        codigoExterno,
        numero: orderNumber,
        status: STATUS.CANCELADO,
        motivo: "",
        nomeAutorizador,
        emailAutorizador,
        canalDeVendas,
        loja,
      })
    ).then(() => setState({ update: true }));
    setState({ modalOpen: false });
  };

  const confirmText = (
    <>
      <Typography className={classes.text}>
        Tem certeza que deseja <b>cancelar</b> o pedido #{numero}?
      </Typography>
      {isPegueNaLoja && (
        <Typography className={classes.pegueText}>
          Após o cancelamento deste pedido, ele deve ser preparado para coleta
          da transportadora.
        </Typography>
      )}
    </>
  );

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth={false}
      PaperProps={{ className: classes.paper }}
    >
      {requireAutorizador ? (
        <>
          <div className={classes.header}>{confirmText}</div>
          <Authorization
            action={handleCancelar}
            cancel={handleClose}
            cancelText="Fechar"
            actionText={isPegueNaLoja ? "Solicitar Coleta" : "Cancelar Pedido"}
            endIcon={isPegueNaLoja ? null : <BlockIcon />}
          />
        </>
      ) : (
        <div className={classes.content}>
          {confirmText}

          <Divider className={classes.divider} />

          <div className={classes.footer}>
            <Button variant="outlined" color="primary" onClick={handleClose}>
              Fechar
            </Button>
            <Button
              variant="contained"
              color="primary"
              disableElevation
              startIcon={isPegueNaLoja ? null : <BlockIcon />}
              onClick={() => handleCancelar()}
            >
              {isPegueNaLoja ? "Solicitar coleta" : "Cancelar Pedido"}
            </Button>
          </div>
        </div>
      )}
    </Dialog>
  );
}
